// utils/formatters.js

// 숫자 포맷팅 (한국 형식으로 콤마 추가)
export const formatNumber = (num) => {
  return new Intl.NumberFormat('ko-KR').format(num);
};

// 통화 포맷팅
export const formatCurrency = (num) => {
  return `${formatNumber(num)}원`;
};

// 날짜 포맷팅
export const formatDate = (dateString) => {
  const date = new Date(dateString);
  return date.toLocaleDateString('ko-KR', {
    year: 'numeric',
    month: '2-digit',
    day: '2-digit'
  });
};

// 전화번호 포맷팅
export const formatPhoneNumber = (phone) => {
  // 기본적인 전화번호 포맷팅 (예: 010-1234-5678)
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 11) {
    return cleaned.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  } else if (cleaned.length === 10) {
    return cleaned.replace(/(\d{2})(\d{4})(\d{4})/, '$1-$2-$3');
  }
  return phone;
};

// 사업자번호 포맷팅
export const formatBusinessNumber = (number) => {
  const cleaned = number.replace(/\D/g, '');
  if (cleaned.length === 10) {
    return cleaned.replace(/(\d{3})(\d{2})(\d{5})/, '$1-$2-$3');
  }
  return number;
};